const qcNoteDE = {
    "view": {
        "message": {
            "releaseHasQCIssues": "Veröffentlichung {{releaseName}} hat QC-Probleme, bitte bearbeiten Sie die Veröffentlichung für detailliertes QC-Feedback, nehmen Sie die erforderlichen Änderungen vor und reichen Sie sie erneut ein!",
            "trackHasQCIssues": "Titel {{trackName}} hat QC-Probleme, bitte bearbeiten Sie den Titel für detailliertes QC-Feedback, nehmen Sie die erforderlichen Änderungen vor und reichen Sie ihn erneut ein!"
        }
    }
};

export default qcNoteDE;